import React, { useState } from 'react'
import "./FifthSection.css"
import { Container } from 'react-bootstrap'
import img1 from "../../Assets/images/Vector5.png"
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import RegistrationPopup from '../registrationPopUp/RegistrationPopup';
import { Modal } from 'antd';

function FifthSection() {

  const { t } = useTranslation();

  const [isModalOpen, setIsModalOpen] = useState(false);

  const navigate = useNavigate();
  return (
    <div className='fifth-section mt-5'>
      <Container>
        <h4>{t('what_our_learners_say')}</h4>
        <img src={img1} alt='' className='w-100' />
        <div id="carouselExampleIndicators" className="carousel slide" data-bs-ride="carousel" data-bs-interval="5000">
          <div className="carousel-indicators">
            <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="0"
              className="active" aria-current="true" aria-label="Slide 1"></button>
            <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="1"
              aria-label="Slide 2"></button>
          </div>

          <div className="carousel-inner">
            {/* Slide 1 */}
            <div className="carousel-item active">
              <div className="row my-3 pb-5 gx-5 mx-5">
                <div className="col-lg-6">
                  <div className="card h-100">
                    <p>{t("testimonial_1_text")}</p>
                    <h5 className='mt-3'>{t("testimonial_1_author")}</h5>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="card h-100">
                    <p>{t("testimonial_2_text")}</p>
                    <h5 className='mt-3'>{t("testimonial_2_author")}</h5>
                  </div>
                </div>
              </div>
            </div>

            {/* Slide 2 (duplicate or can be changed) */}
            {/* <div className="carousel-item">
              <div className="row my-3 pb-5 gx-5 mx-5">
                <div className="col-lg-6">
                  <div className="card h-100">
                    <p>{t("البرنامج يعطيني من النحو والصرف ما أحتاج إليه في المستوى الذي أنا فيه وهكذا شيئاً فشيئاً مع التدريبات أصبحت أفهم ما كنت لا أفهم من كتب النحو والصرف")}</p>
                    <h5 className='mt-3'>{t('على من داغستان')}</h5>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="card h-100">
                    <p>{t('testimonials.testimonial2.text')}</p>
                    <h5 className='mt-3'>{t('testimonials.testimonial2.name')}</h5>
                    <h6>{t('testimonials.testimonial2.title')}</h6>
                  </div>
                </div>
              </div>
            </div> */}
          </div>

          {/* Controls */}
          <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="prev">
            <span className="carousel-control-prev-icon" aria-hidden="true"></span>
            <span className="visually-hidden">{t('testimonials.prev')}</span>
          </button>
          <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="next">
            <span className="carousel-control-next-icon" aria-hidden="true"></span>
            <span className="visually-hidden">{t('testimonials.next')}</span>
          </button>
        </div>
      </Container>
      <div className='fifth-section-footer mt-5'>
        <h3>{t('start_arabic_journey')}</h3>
        <p>{t('kalemon_description')}</p>
        <div className='fifth-section-footer-btns'>
          {/* <button
            className='btn takeplacement'
            onClick={() => setIsModalOpen(true)}
          >
            {t('take_placement_test')}
          </button> */}

          <button
            className='btn explore'
            onClick={() => navigate("/all-programs")}
          >
            {t('explore_all_programs')}
          </button>
        </div>
      </div>
      <Modal
        open={isModalOpen}
        footer={null}
        destroyOnClose
        onCancel={() => setIsModalOpen(false)} // close handler
        width={"80vw"}

      >
        <RegistrationPopup setIsModalOpen={setIsModalOpen} />
      </Modal>
    </div>
  );
}

export default FifthSection
